import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Inbox } from "lucide-react";
import { adminApi, errorMessage } from "../../lib/api";
import { WorkerCard } from "./WorkerSearch";

export const Applications = ({ fee, refresh, onChange }) => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    adminApi.get("/employer/applications").then((r) => setItems(r.data)).catch((e) => toast.error(errorMessage(e)));
  }, []);
  useEffect(() => { load(); }, [load, refresh]);
  const act = (path, msg) => adminApi.post(path).then(() => { toast.success(msg); load(); onChange(); }).catch((e) => toast.error(errorMessage(e)));
  if (!items) return null;
  return (
    <section data-testid="employer-applications" className="space-y-4">
      <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-white"><Inbox className="h-5 w-5 text-orange-400" />Applications received
        <span className="text-base font-normal text-slate-500" data-testid="applications-count">({items.length})</span></h2>
      {items.length === 0 && <p data-testid="applications-empty" className="text-slate-500">No applications yet. Employees who apply to your vacancies will show here.</p>}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((a) => (
          <div key={a.id} data-testid={`application-${a.id}`} className="space-y-1">
            <p className="text-xs text-slate-500">For <b className="text-slate-300">{a.listing_role}</b> · {a.listing_place} · {new Date(a.applied_at).toLocaleDateString("en-IN")}
              {!a.kyc_verified && <span className="ml-1 text-amber-500">· KYC pending</span>}</p>
            {a.kyc_verified ? (
              <WorkerCard w={a.worker} fee={fee} scope={`app-${a.id}-`}
                onUnlock={(x) => act(`/employer/workers/${x.id}/unlock`, "Contact unlocked")}
                onHire={(x) => act(`/employer/workers/${x.id}/hire`, "Joining OTP generated. Ask the employee for the 4-digit code at site.")} />
            ) : (
              <article data-testid={`application-kyc-pending-${a.id}`} className="border border-white/10 bg-[#0F172A] p-5">
                <p className="font-semibold text-white">{a.worker.name}</p>
                <p className="mt-1 text-sm text-slate-400">{a.worker.job_role} · {a.worker.district}, {a.worker.state}</p>
                <p className="mt-4 w-full border border-amber-500/30 bg-amber-500/10 py-2 text-center text-sm font-semibold text-amber-500">Contact available after KYC</p>
              </article>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
